import { netsparkAxios } from 'core/services/HTTPService';
import { getEngagementTypeUrl } from 'pages/Dashboard/api/apiUrls';
import { IEngagementsTotalItem } from 'pages/Dashboard/Dashboard.models';
// eslint-disable-next-line no-unused-vars
import { TPeriod } from 'shared/CustomRangePicker/CustomRangePicker.models';

export const getEngagementType = (signal: AbortSignal, params: TPeriod) => netsparkAxios
  .get<IEngagementsTotalItem[]>(getEngagementTypeUrl, { signal, params });
